import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * The mono voice (DESIGN.md §4): uppercase, tracked, small. Used for section labels, area names,
 * hours and counts — the parts of the page a turnstile would read.
 *
 * `index` is optional and deliberately rare: it renders only where the content is genuinely an
 * ordered sequence (the three how-it-works steps). Numbering anything that is not a sequence
 * would be decoration pretending to be structure.
 */
export function Eyebrow({
  children,
  index,
  tone = "default",
  className,
  as: Tag = "p",
}: {
  children: React.ReactNode;
  index?: number;
  tone?: "default" | "signal" | "onBand";
  className?: string;
  as?: "p" | "span" | "div";
}) {
  return (
    <Tag
      className={cn(
        "font-mono text-micro uppercase",
        tone === "default" && "text-muted",
        tone === "signal" && "text-signal",
        tone === "onBand" && "text-band-muted",
        className,
      )}
    >
      {/* A token, not an alpha of one: `text-ink-2/60` measured 1.2:1 on the dark ground. */}
      {index !== undefined && (
        <span className="text-muted tabular-nums">
          {String(index).padStart(2, "0")}
          <span className="px-2" aria-hidden="true">
            /
          </span>
        </span>
      )}
      {children}
    </Tag>
  );
}
